import { useWebContentUrl } from '@core/js/components/system/WebContent/hooks';
import { get } from '@core/js/utils/fetch.util';

import { shouldFetch } from '@interlayer/js/app/components/system/WebContent/helpers';
import { useDataFetchWithAwait } from '@interlayer/js/app/hooks/useDataFetchWithAwait';
import { useUpdateEffect } from '@interlayer/js/hooks/useUpdateEffect';

import { TUseGetWebContentDataProps } from '../types';

export const useGetWebContentData = <T, R = T>({ id, content, url, onResponse }: TUseGetWebContentDataProps<T, R>) => {
    const webContentUrl: string = useWebContentUrl({ webContentId: id, url });

    const data = useDataFetchWithAwait<T, R, string>({
        fetch: get,
        params: webContentUrl,
        initialData: content,
        onResponse,
        initFetch: true,
        shouldFetch
    });

    useUpdateEffect(() => {
        data.fetch({ paramsFetch: webContentUrl });
    }, [webContentUrl]);

    return data;
};
